module.exports = __webpack_public_path__ + "static/media/kp.cf52519e.webp";